import { render } from "./RankHeader.vue?vue&type=template&id=c9c31dd6&scoped=true"
import script from "./RankHeader.vue?vue&type=script&lang=js"
export * from "./RankHeader.vue?vue&type=script&lang=js"

import "./RankHeader.vue?vue&type=style&index=0&id=c9c31dd6&scoped=true&lang=css"

import exportComponent from "/usr/share/nginx/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c31dd6"]])

export default __exports__